import * as Sentry from '@sentry/vue'
import { App } from 'vue'
import { Router } from 'vue-router'
import PackageJson from '../../package.json'
import { Settings } from '@/types'

export default {
  install: (app: App<Element>, options: { router: Router; settings: Settings }) => {
    Sentry.init({
      release: `${PackageJson.name}@${PackageJson.version}`,
      dsn: options.settings.sentryKey ?? '',
      app,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      tracesSampleRate: 1.0,
      integrations: [
        Sentry.browserTracingIntegration({ router: options.router }),
        Sentry.replayIntegration()
      ],
      trackComponents: true,
      logErrors: true,
      environment: options.settings.environment,
      tracePropagationTargets: [options.settings.backendUrl]
    })
  }
}
